import { ChartType, Organization } from '../types';
import { CSV, GIF, PDF, PNG, XLS } from './file-format';

// Exports
export const getAvailableExportOptions = (organization: Partial<Organization> | null): string[] =>
    organization?.available_export_options || [];

export const isExportEnabled = (organization: Partial<Organization> | null, type: string) =>
    getAvailableExportOptions(organization).includes(type);

export const isExcelExportEnabled = (organization: Partial<Organization> | null) =>
    isExportEnabled(organization, XLS);

export const isPngExportEnabled = (organization: Partial<Organization> | null) =>
    isExportEnabled(organization, PNG);

export const isCsvExportEnabled = (organization: Partial<Organization> | null) =>
    isExportEnabled(organization, CSV);

export const isPdfExportEnabled = (organization: Partial<Organization> | null) =>
    isExportEnabled(organization, PDF);

export const isGifExportEnabled = (organization: Partial<Organization> | null) =>
    isExportEnabled(organization, GIF);

// Chart types
export const getAvailableChartTypes = (organization: Partial<Organization> | null): ChartType[] =>
    organization?.available_chart_types || [];

export const isChartTypeEnabled = (type: ChartType, organization: Partial<Organization> | null) =>
    getAvailableChartTypes(organization).includes(type);

// Single-Year Age Estimates
export const isSingleYearAgeEstimatesExportEnabled = (
    organization: Partial<Organization> | null
): boolean => !!(organization && organization.single_year_age_data_query_is_allowed);
